import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function LockIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path stroke={color || defaultColor} fill="none"
          d="M1.88768 10.6061C2.0503 12.0408 3.26353 13.1594 4.70649 13.2106C5.43845 13.2366 6.19004 13.25 7.00008 13.25C7.81013 13.25 8.56171 13.2366 9.29367 13.2106C10.7366 13.1594 11.9499 12.0408 12.1125 10.6061C12.1692 10.1061 12.2084 9.59799 12.2084 9.08335C12.2084 8.56872 12.1692 8.06065 12.1125 7.56059C11.9499 6.1259 10.7366 5.00729 9.29367 4.95608C8.56171 4.93011 7.81013 4.91669 7.00008 4.91669C6.19004 4.91669 5.43845 4.93011 4.70649 4.95608C3.26353 5.00729 2.0503 6.1259 1.88768 7.56059C1.831 8.06065 1.79175 8.56872 1.79175 9.08335C1.79175 9.59799 1.831 10.1061 1.88768 10.6061Z" />
    <path stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M9.91659 4.91667V3.66667C9.91659 2.89312 9.60929 2.15125 9.06231 1.60427C8.51533 1.05729 7.77347 0.75 6.99992 0.75C6.22637 0.75 5.48451 1.05729 4.93752 1.60427C4.39054 2.15125 4.08325 2.89312 4.08325 3.66667V4.91667" />
    <path stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M7 8.50006L7 9.5" />
  </SvgIcon>
}
